/*
 * @Author: Fan
 * @Date: 2020-04-16 19:59:30
 * @description: 组件schema集成中心. 如果组件schema有继承,注册器
 * @LastEditors: Fan
 */
export * from "./src/common/component-schema";
